import { useEffect } from 'react'
import { getModalControlStore } from '@/domains/header/model/store.ts'
import { useAccount } from '@lair-finance/wagmi'

export function useCloseMenuOnDisconnect() {
  const { isConnected } = useAccount()

  useEffect(() => {
    if (!isConnected) {
      getModalControlStore().closeModal()
    }
  }, [isConnected])
}
